import axios from 'axios'
import router from '../../router'

const state = {
  adminlogInfo: {},
  totalPages: 0
}

const getters = {
  getAdminlogInfo: state => {
    return state.adminlogInfo
  },
  getTotalPage: state => {
    return state.totalPages
  }
}

const mutations = {
  setAdminlogInfo (state, payload) {
    state.adminlogInfo = payload
  },
  setAdminLogTotalPages (state, payload) {
    state.totalPages = payload
  }
}
const actions = {
  apiAdminLoginlog (context, payload) {
    let curPage = 0
    if (payload !== undefined) {
      curPage = payload - 1
    }
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.get('/api/admin/loginlog?page=' + curPage)
        .then((response) => {
          context.commit('setAdminlogInfo', response.data)
          context.commit('setAdminLogTotalPages', response.data.totalPages)
        })
        .catch((error) => {
          alert(error.response.data.message)
          if (error.response.status === 410) {
            sessionStorage.removeItem('token')
            router.push('/sessiontimeout')
          }
        })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/sessiontimeout')
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/adminlog.js